import { useTranslation } from 'react-i18next';

const formatNumber = (num) => {
  if (num === null || num === undefined) return '';
  return Number(num).toLocaleString('en-US');
};
export default function OrderDetails({
  trackingNumber,
  products,
  codAmount,
  onQtyChange,
  onUpdateAmounts,
  onProceed,
  onImageClick,
  isBundleControllable,
  groupProductsByBundle,
  isUpdatingAmounts,
}) {
  const { t } = useTranslation();
  const productGroups = groupProductsByBundle(products);
  return (
    <div className="capitalize">
      <h1 className="mb-4 text-xl font-bold leading-8 text-center">{t('ShipBlu Try & Buy Service')}</h1>

      <div className="bg-white rounded-lg border-2 border-coconut-white p-3 mb-4 text-center">
        <p className="text-berwick-berry mb-1 text-sm">{t('Tracking Number')}</p>
        {trackingNumber ? (
          <p className="font-semibold text-Squid-Ink-Powder">{trackingNumber}</p>
        ) : (
          <p className="text-center">{t('No data available')}</p>
        )}
      </div>

      <p className="font-semibold mb-2">{t('Product basket')}</p>
      <div className="mb-4 flex flex-col gap-2">
        { 
          productGroups.length === 0 ? (
            <p className="text-center p-2 rounded-lg border-2 border-coconut-white">{t('No data available')}</p>
          ) : (
          productGroups.map((group) => {
            const isBundle = group.length > 1;
            const rows = group.map((p) => {
              const controllable = isBundleControllable(p);
              return (
                <div key={p.id} className={`flex items-center gap-2 ${isBundle ? 'py-2' : 'p-2 rounded-lg border-2 border-coconut-white'}`}>
                  <img
                    src={p.image}
                    alt={p.name}
                    onClick={() => onImageClick(p.image)}
                    className="w-16 h-16 flex-shrink-0 p-1 rounded-md border border-solid border-coconut-white object-contain cursor-pointer"
                  />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium truncate text-funnel-cloud">{p.name}</p>
                    <p className="text-sm text-berwick-berry">{t('price')}: {formatNumber(p.price)} {t('EGP')}</p>
                    {codAmount === null ? (
                      <div className="flex items-center gap-1.5 mt-1">
                        <button
                          onClick={() => onQtyChange(p.id, -1)}
                          disabled={p.receivedQty <= 0 || !controllable}
                          aria-label={t('Decrease quantity')}
                          className="w-6 h-6 rounded-full border border-morning-chill flex items-center justify-center text-lg text-funnel-cloud disabled:opacity-30 disabled:cursor-not-allowed flex-shrink-0"
                        >
                          <span>-</span>
                        </button>
                        <span className="w-4 text-center text-sm flex-shrink-0 text-funnel-cloud">{p.receivedQty}</span>
                        <button
                          onClick={() => onQtyChange(p.id, 1)}
                          disabled={p.receivedQty >= p.maxQty || !controllable}
                          aria-label={t('Increase quantity')}
                          className="w-6 h-6 rounded-full border border-morning-chill flex items-center justify-center text-lg text-funnel-cloud disabled:opacity-30 disabled:cursor-not-allowed flex-shrink-0"
                        >
                          <span>+</span>
                        </button>
                        <span className="text-sm text-berwick-berry truncate">{t('Quantity received')}</span>
                      </div>
                    ) : (
                      <p className="text-sm text-berwick-berry">{t('Quantity received')}: {p.receivedQty}</p>
                    )}
                  </div>
                  {codAmount !== null && (
                    <div className="font-bold whitespace-nowrap flex-shrink-0 text-Squid-Ink-Powder">
                      {formatNumber(p.price * p.receivedQty)} {t('EGP')}
                    </div>
                  )}
                </div>
              );
            });

            if (!isBundle) {
              return rows[0];
            }

            const baseItem = group.find((p) => isBundleControllable(p)) || group[0];

            return (
              <div
                key={group[0].bundleId}
                className="rounded-lg border-2 border-coconut-white px-2"
              >
                <p className="text-sm font-semibold text-bright-blue pt-2 pb-1">
                  {t('Bundle Qty')}: {baseItem.receivedQty}
                </p>
                <div className="divide-y divide-coconut-white">{rows}</div>
              </div>
            );
          }))}
      </div>

      {codAmount === null && (
        <button
          onClick={onUpdateAmounts}
          disabled={isUpdatingAmounts}
          className="capitalize flex items-center gap-2 justify-center h-11 w-full bg-bright-blue text-white rounded-md font-medium shadow-[0_6px_14px_rgba(0,95,255,0.25)] transition hover:bg-frosted-blueberries focus:outline-none focus:ring-2 focus:ring-arc-light focus:ring-offset-2"
        >
          {isUpdatingAmounts && (
            <span className="w-4 h-4 border-2 shrink-0 border-coconut-white border-t-transparent rounded-full animate-spin"></span>
          )}
          {t('Update amounts')}
        </button>
      )}

      {codAmount !== null && (
        <div className="bg-calcareous-sinter rounded-lg p-3 mb-4 text-center">
          <p className="text-sm text-berwick-berry mb-1">{t('Target amount')} (COD)</p>
          <p className="text-xl font-bold text-bright-blue">{formatNumber(codAmount)} {t('EGP')}</p>
        </div>
      )}

      {codAmount !== null && (
        <button
          onClick={onProceed}
          className="capitalize flex items-center gap-2 justify-center h-11 w-full bg-bright-blue text-white rounded-md font-medium shadow-[0_6px_14px_rgba(0,95,255,0.25)] transition hover:bg-frosted-blueberries focus:outline-none focus:ring-2 focus:ring-arc-light focus:ring-offset-2"
        >
          {t('Follow-up to confirm changes')}
        </button>
      )}
    </div>
  );
}